import { createBrowserHistory } from 'history';

import { appMethod as app } from '@utils/app';

import { updateUrlParam } from '@utils/tools';

const history =  createBrowserHistory({
  basename: BASENAME || '/', // 配置的全局常量 webpack.definePlugin webpack.cofig.js/webpack.prod.js中修改
});

const location = history.location;

const unlisten = history.listen((location, action) => {
  // 前一页面为自定义页面，执行前一页面组件销毁
  let pageInstance = app.getAppCurrentPage();
  if (pageInstance && pageInstance.customPageRef) {
    app.onPageUnload();
  }
  // WEBAPP:清除当前页面内弹窗内容（例如：预览大图等）
  ReactDOM.unmountComponentAtNode(document.getElementById('popup'));

  // The action is one of PUSH, REPLACE, or POP depending on how the user got to the current URL.
  console.log('路由处理中...', 'location:', location, 'action:', action)
  // 默认把app_id加到当前地址栏参数中（防止用户分享当前链接）
  updateUrlParam('app_id', app.getAppId());
  // 传递给父级窗口message
  if (window.top !== window) {
    var data = JSON.stringify({
      iframeId: window.frameElement ? window.frameElement.id : null,
      name: 'turnToPage',
      url: window.location.href,
      router: location.pathname.replace('/', ''),
    })
    window.parent.postMessage(data, '*');
  }
  let route = location.pathname.split('/')[1];
  let page = {
    route: route,
    data: {},
    callbackData: null,
    setData: function(data) {
      if (this.callbackData) {
        this.callbackData = {...this.callbackData, ...data}
      } else {
        this.callbackData = data;
      }
    },
    clearCallbackData: function() {
      this.callbackData = null;
    }
  };
  if (action === 'PUSH' || action === 'REPLACE') {
    if (app.globalData.tabBarPagePathArr.indexOf(route) > -1) {
      // 跳转到有设置底部导航的页面，页面清空并设置为当前页
      app.globalData.currentPages = [page];
    } else {
      // 推入页面栈中
      if (action === 'REPLACE') {
        app.globalData.currentPages.pop();
      }
      if (action !== 'REPLACE' && app.getAppCurrentPage() && app.getAppCurrentPage().state) {
        app.getCurrentPage().data = JSON.parse(JSON.stringify(app.getAppCurrentPage().state));
      }
      app.globalData.currentPages.push(page);
    }
  } else if (action === 'POP') {
    if (app.globalData.currentPages.length > 1) {
      // 页面栈超过一个页面（不含一个）, 去掉最后一个
      app.globalData.currentPages.pop();
    } else {
      // 页面栈仅剩一个, 页面清空并设置为当前页
      app.globalData.currentPages = [page];
    }
  }
});

// To stop listening, call the function returned from listen().
// unlisten();

export {
  history,
  location,
  unlisten,
}


// WEBPACK FOOTER //
// ./src/history.jsx